function f(t) {
  var n = t.match(/^var\((.*)\)$/);
  return n ? n[1] : t;
}
function s(t, n) {
  var o = t;
  for (var e of n) {
    if (!(e in o))
      throw new Error("Path ".concat(n.join(" -> "), " does not exist in object"));
    o = o[e];
  }
  return o;
}
function c(t, n) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], e = {};
  for (var i in t) {
    var r = t[i], a = [...o, i];
    typeof r == "string" || typeof r == "number" || r == null ? e[i] = n(r, a) : typeof r == "object" && !Array.isArray(r) ? e[i] = c(r, n, a) : console.warn('Skipping invalid key "'.concat(a.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(r) ? "Array" : typeof r, '"'));
  }
  return e;
}
export {
  s as get,
  f as getVarName,
  c as walkObject
};
//# sourceMappingURL=vanilla-extract-private.esm.mjs.map
